export default __webpack_public_path__ + "static/media/chat-message-icon.18165e42.svg";